module.exports = __webpack_public_path__ + "img/segment.2652c99e.png";